import React from 'react';
import { Card as MuiCard, CardContent, Typography, Grid, Box } from '@mui/material';
import { grey } from '@mui/material/colors';
import ArchiveIcon from '@mui/icons-material/Archive';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';

export function Card({ issue, onArchiveClick }) {
  const formattedDate = format(new Date(issue?.updated_at), 'dd/MM/yyyy HH:mm');
  const navigate = useNavigate();

  const limitedTitle = issue?.content?.length > 60 ? `${issue?.content?.slice(0, 60)}...` : issue?.content;

  return (
    <Grid item xs={6} sm={4} md={3} style={{ paddingRight: '12px', marginBottom: '12px' }}>
      <Box style={{ width: '100%', height: '100%', marginTop: '12px' }}>
        <div
          style={{ width: '100%', height: '100%', cursor: 'pointer' }}
          onClick={() => navigate(`/issue-details/issue/${issue?.id}`)}
          onKeyDown={event => {
            if (event.key === 'Enter' || event.key === ' ') {
              navigate(`/issue-details/issue/${issue?.id}`);
            }
          }}
          role='button'
          tabIndex={0}
        >
          <MuiCard style={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100%' }}>
            <CardContent
              style={{
                flexGrow: 1,
                textAlign: 'start',
                backgroundColor: grey[300],
                padding: '16px',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Grid container>
                <Grid item xs>
                  <Typography variant='body2' style={{ fontWeight: 600 }}>
                    {limitedTitle}
                  </Typography>
                </Grid>
                <Grid item>
                  <IconButton
                    size='small'
                    style={{ padding: 0 }}
                    onClick={e => {
                      e.stopPropagation();
                      onArchiveClick();
                    }}
                    onMouseDown={e => {
                      e.stopPropagation();
                      onArchiveClick();
                    }}
                  >
                    <ArchiveIcon fontSize='small' />
                  </IconButton>
                </Grid>
              </Grid>
              {issue?.email && (
                <>
                  <Typography
                    variant='body2'
                    style={{ marginTop: 'auto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                  >
                    {issue.email}
                  </Typography>

                  <Typography
                    variant='body2'
                    style={{ marginTop: '16px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                  >
                    {formattedDate}
                  </Typography>
                </>
              )}
            </CardContent>
          </MuiCard>
        </div>
      </Box>
    </Grid>
  );
}
